import React from 'react';
import SupportPageUser from './SupportPage.user';

export default function SupportPage() {

  return <SupportPageUser />;
}
